import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import '../../common.css';
import { BiVolumeLow } from 'react-icons/bi';
import { getAccessToken } from "../../services/authApi";
const { getConditions, getAttachments } = require("../../services/loanApi");

const AI_FUNCTIONAPP_API_URL = process.env.REACT_APP_AI_FUNCTIONAPP_API_URL;
const AI_FUNCTIONAPP_API_KEY = process.env.REACT_APP_AI_FUNCTIONAPP_API_KEY;

const AILoanSummary = ({ loanJson, prompt = "Provide a concise summary and key risks of this loan." }) => {
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState("");
  const [error, setError] = useState("");


  useEffect(() => {
          const initialize = async () => {
              if (window.elli && window.elli.script && window.elli.script.guest) {
                  window.elli.script.guest.create();
  
                  //await initializeAuthObject(); // Wait for status to load
              } else {
                  console.warn("elli.script.guest is not available.");
                  setLoading(false); // Only set to false after everything loads
              }
  
          };
          initialize();
      }, []);


  const getLoanConditionAndAttachments = async (loanid) => {
          const tpoAuthObject = await window.elli.script.getObject("auth");
            const tokenObj = await tpoAuthObject.getAccessToken();
            const token = tokenObj?.access_token || tokenObj?.token || tokenObj;
          //const token = await getAccessToken(authCode);
            if (token) {
              // Use loanApi.js to get conditions
                const [conditions, attachments] = await Promise.all([
                getConditions(token, loanid),
                getAttachments(token, loanid)
                ]);
                return {
                conditions: conditions || [],
                attachments: attachments || []
                };
            }

      };

  

  const getPayload = async () => {
    try {
      const loanObject = await window.elli.script.getObject("loan");
      const loan = await loanObject.all();
      // Return the object as required for further processing
      console.log("Fetched loan from ElliMae:", loan);
      return {
        file_json: loan.loan
      };
    } catch (err) {
      console.error("Error fetching loan from ElliMae:", err);
      setError("Failed to fetch loan data from ElliMae. " + err.message);
      return null;
    }
  };



  const fetchSummary = async () => {
    console.log("Fetching AI Loan Summary...");
    setLoading(true);
    setError("");
    try {
      
      const payload = await getPayload();
      console.log("Payload for AI Loan Summary:", payload);
      if (!payload) {
        setLoading(false);
        return;
      }

      // Get loan id from payload (assuming file_json contains loanId)
      const loanId = payload.file_json?.id
      let conditions = [];
      let attachments = [];
      if (loanId) {
        const { conditions: conds, attachments: atts } = await getLoanConditionAndAttachments(loanId);
        conditions = conds;
        attachments = atts;
        console.log("Fetched conditions and attachments:", conditions, attachments);
        // You can use 'atts' as needed, e.g., include in apiPayload if required
      }

      const apiPayload = {
        loanData: payload.file_json,
        conditions: conditions,
        attachments: attachments,
      };

      const tpoAuthObject = await window.elli.script.getObject("auth");
      const authCode = await tpoAuthObject.createAuthCode();

      const res = await fetch(`${AI_FUNCTIONAPP_API_URL}/analyze-loan`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": AI_FUNCTIONAPP_API_KEY,
          "Authorization": `Bearer ${authCode}`
        },
        body: JSON.stringify(apiPayload)
      });

      if (!res.ok) {
        throw new Error(`Server returned ${res.status}`);
      }
      const data = await res.json();
      setResponse(data.summary_and_crux || "No summary received.");
    } catch (err) {
      console.error("AI Loan Summary error:", err);
      setError("Failed to fetch AI summary. " + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-md p-4">
      {/* <h2 className="text-lg font-semibold mb-4">AI Loan Summary</h2> */}
      <button
        onClick={fetchSummary}
        disabled={loading}
        className="btn-custom rounded text-white bg-[#2080C3] hover:bg-[#5DA5D9] px-4 py-2 font-semibold"
      >
        {loading ? "Processing..." : "Show AI Loan Summary"}
      </button>

      {error && (
        <div className="mt-4 text-red-600">
          {error}
        </div>
      )}

      {response && (
        <div className="mt-4 p-4 border rounded bg-gray-50 text-sm prose max-w-none">
          <ReactMarkdown>{response}</ReactMarkdown>
        </div>
      )}
    </div>
  );
};

export default AILoanSummary;
